module.exports = __webpack_public_path__ + "static/mobile-app-img-2-498f6f187718ea280a679d380bfc4328.png";